<template>
  <div style="padding:1px;">
    <hd></hd>
    <div class="contioner">
        <h1 class="title">{{offerName}}</h1>
        <el-row>         
            <el-col :span="24" class="goodsList">
                <dd v-if="loading" class="text-center">
                    <Loading></Loading>
                </dd>
                <el-row v-if="!loading" class="goods">
                    <el-col :span="24" v-if="goodList.length == '0'">
                        当前的品牌和分类暂无商品
                    </el-col>
                    <el-col :md="6" :sm="8" :xs="12" :lg="4" v-for="(item,index) in goodList" :key="index">
                        <div class="goodList">
                            <div class="click">
                                <div class="goodImg" >
                                    <div class="ImgLoading" v-if="item.showLoading">
                                        <img  src="../../assets/images/bizarro-loader-30x30.gif">
                                    </div>
                                    <!-- <add-products :product="item" :business="business" v-on:success="success" :description='item.description'> -->
                                        <img  :src="item.image_url">
                                    <!-- </add-products> -->
                                </div>
                            <div>
                                <div class="goodName">
                                    {{item.name}}
                                </div>
                            </div>
                            <div>
                                <div class="goodprice" v-if="item.price!=item.discounted_price">
                                    <div class="mobilePrice">
                                        <del>
                                            {{currency_symbol}}{{item.price}}
                                        </del>
                                    </div>
                                    <div class="mobilePrice">
                                        <span>
                                            {{currency_symbol}}{{item.discounted_price}}
                                        </span>
                                    </div>

                                </div>
                                <div v-else>
                                    <div>
                                        {{currency_symbol}}{{item.price}}
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
    <!--<div class="yd-pagination" v-if="goodList && totalCount > form.limit" style="margin-bottom:20px;">
        <el-pagination
          :page-size="form.limit"
          :pager-count="5"
          :current-page.sync="form.page"
          layout="prev, pager, next"
          next-text="下一页"
          prev-text="上一页"
          :total="totalCount">
        </el-pagination>
      </div>-->
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
    <GlobalDialogs></GlobalDialogs>
  </div>
</template>

<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import api from '../../services/api.js'
import AddProducts from './AddProducts'
import { CURRENCIES } from '../../services/constant'
import mobilefooter from '../../components/mobilefooter'
import Loading from '../../components/Loading'
import errImag from '../../ico/uploadpic@2x.png'
import GlobalDialogs from '../../components/GlobalDialogs'
let _ = require('lodash')
let $ = require('jQuery')

export default {
  name: 'Brands',
  components: {
    hd: hd,
    ft: ft,
    mobilefooter: mobilefooter,
    AddProducts: AddProducts,
    Loading: Loading,
    GlobalDialogs: GlobalDialogs
  },

  data () {
    return {
      form: {
        page: Number(this.$route.query.page) || 1,
        limit: 30,
        tag_name: null,
        brand_name: null,
        price_order: null,
        level: '',
        level_id: null
      },
      tagUrl: [],
      checked: false,
      lastTag: false,
      title: 'Sephora',
      showLoading: true,
      activeNames: '1',
      errorUserPhoto: 'this.src="' + errImag + '"',
      showRefine: false,
      showSort: false,
      loading: true,
      mobiletype: false,
      screenWidth: document.body.clientWidth,
      CURRENCIES: CURRENCIES,
      business_id: '',
      business: {},
      url: null,
      goodList: '',
      time: '',
      website: '',
      completion: false,
      totalCount: null,
      tagList: null,
      brandList: null,
      activeIndex: '1',
      sort: [
        {value: 'asc', label: '价格:从低到高'},
        {value: 'desc', label: '价格:从高到低'}
      ],
      checkList: [],
      tagCheckList: [],
      mobileLevel: [],
      brandInput: null,
      newBrandList: null,
      i: 0, // 计数器,
      isSort: false,
      isRefine: false,
      backTagUrl: [],
      backCheckList: [],
      timer: false,
      keyword: null,
      tag: null,
      currency:'',
      currency_symbol:'',
      offerName:''
    }
  },
  created () {
    this.tag = this.$route.params.id
    this.keyword = localStorage.getItem('SearchKeyword')
    if (document.body.clientWidth <= 1160) {
      this.mobiletype = true
    }
    this.time = new Date().getTime()
    if (this.$route.query.tag) {
      this.form.tag = this.$route.query.tag
    }
    this.business.id = this.$route.params.id
    // this.getLevelListByBusiness()
    // this.getBrandListByBusiness()
    this.getGoodList(this.tag)
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    async getGoodList (tag) {
      this.loading = true
      let params = {
        unique_offersales:tag,
        page:1,
        limit:400
      }
      let res = await api.getOfferGoodsList(this, params)
      if (res.body.status == 'ok') {
        this.loading = false
        this.currency=res.body.result.currency;
        this.currency_symbol=res.body.result.currency_symbol;
        //this.showLoading = true
        this.goodList = res.body.result.good_list;
        this.offerName=res.body.result.unique_offersales;
        /*_.each(this.goodList, item => {
          item.showLoading = true
        })*/
      }
    },
    async getGoodCount () {
      this.loading = true
      let params = {
        tag_name: this.form.tag_name,
        brand_name: this.form.brand_name,
        price_order: this.form.price_order,
        level: this.form.level,
        keyword: this.keyword,
        tag: this.form.trueTag
      }
      let res = await api.getSephoraGoodCount(this, params)
      if (res.body.status == 'ok') {
        this.totalCount = Number(res.body.result)
      }
    },  
    success () {
      this.completion = true
    },
    showImg (item) {
      item.showLoading = false
      console.log(item)
      this.$forceUpdate()
    },
    imgLoadError (item) {
      item.showLoading = false
      item.picture_url = this.business.logo
      this.$forceUpdate()
    },
  },
  watch: {
    screenWidth (val) {
      if (!this.timer) {
        this.screenWidth = val
        console.log(this.screenWidth)
        if (val <= 1160) {
          this.mobiletype = true
        } else {
          this.mobiletype = false
        }
        console.log(this.mobiletype)
        this.timer = true
        let that = this
        setTimeout(function () {
          // that.screenWidth = tha t.$store.state.canvasWidth
          that.timer = false
        }, 400)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .contioner {
        margin: 154px auto 0;
        max-width: 1500px;
        padding: 0 60px;
        .all {

                color: #666;
                cursor: pointer;
                position: relative;
                font-size: 18px;
                // top: -62px;

                div {
                    display: inline-block;
                    // font-size: 18px;
                    color: #686B73;
                }

                .decoration:hover {
                    text-decoration: underline !important;
                }
                span {
                    display: inline-block;
                    margin-right: 5px;
                }

            }
        .title {
            font-size: 24px !important;
            letter-spacing: 0.1px !important;
            margin: 0px !important;
            display: block !important;
            color: #333333 !important;
            font-weight: 500 !important;
            line-height: 29px !important;
            padding:  0 0 36px 0 !important;
            text-align: center !important;
        }
        .select {
            float: right;
        }
        .navBar {
            position: fixed;
            z-index: 997;
            width: 100%;
            bottom: 0px !important;
            margin-bottom: 30px !important;
            .buttonGroup {
                margin: 0 auto;
                height: 40px !important;
                width: 220px !important;
                background-color: black !important;
                border-radius: 4px !important;
                box-shadow: 0 2px 4px 0 rgba(51,51,51,0.2) !important;

                .button {
                    display: inline-block;
                    width: 46%;
                    text-align: center;
                    color: white !important;
                    font-size: 15px !important;
                    margin: auto !important;
                    padding: 12px 15px !important;

                    .icon {
                        color: #fff !important;
                        letter-spacing: -3px !important;
                        margin-right: 5px !important;

                        &.isSort {
                            color: #FF4650 !important;
                        }

                        img {
                            vertical-align: bottom;
                            width: 20px;
                            height: 14px;
                        }
                    }
                }
                .divider {
                    vertical-align: middle;
                    display: inline-block;
                    padding-top: 5px;
                    height: 26px !important;
                    width: 2px !important;
                    -webkit-align-self: center !important;
                    align-self: center !important;
                    border: 1px solid #686B73 !important;
                }
            }
        }
        .goodsInfo{
            padding: 0 20px;

            .tag {
                color: #333333 !important;
                font-size: 16px !important;
                letter-spacing: 0.1px !important;
                white-space: nowrap !important;
                -webkit-flex-grow: 1 !important;
                flex-grow: 1 !important;
                line-height: 24px !important;
            }
            .tagList {
                // max-height: 216px !important;
                // overflow-y: scroll !important;
                width: 300px;

                div {
                    position: relative;
                    padding: 0 10px;
                    line-height: 24px !important;
                    cursor: pointer;
                    color: #666;

                    span {
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
                div:hover {
                    text-decoration: underline !important;
                    span {
                        text-decoration: underline !important;
                    }
                }
            }
            .input {
                height: 30px !important;
                width: 100% !important;
                display: block !important;
                background-color: #FFF !important;
                border: 1px solid #e1e1e1 !important;
                border-radius: 2px !important;
                line-height: 30px !important;
                text-align: left !important;
                padding: 8px 15px;
                margin-bottom: 10px;
            }
            .wall {
                max-height: 216px !important;
                overflow-y: scroll !important;
                .number {
                    display: inline-block;
                    position: absolute;
                    right: 5px;
                    top: 0;
                }
                .brandList {
                    padding: 5px 10px;
                    cursor: pointer;
                    color: #666;
                }
                .brandList:hover {
                    text-decoration: underline !important;
                }
            }
        }

        .goods {
            text-align: center;
            overflow: hidden;
            padding-top: 25px;
            .goodList {
                margin-bottom: 25px;
                height: 260px;
                cursor: pointer;
                padding: 0 20px;
                .click {
                    cursor: pointer;
                }
                .goodImg {
                    display:inline-block;
                    width:135px;
                    height:135px;
                    margin-bottom: 30px;
                    position: relative;
                    overflow: hidden;
                    .ImgLoading {
                        position: absolute;
                        top: 0;
                        left: 0;
                        display:inline-block;
                        background-color: #F3F3F9 !important;
                        height:135px;
                        width:135px;
                        margin-bottom: 21px;
                        img {
                            height: 30px;
                            width: 30px;
                            margin-top: 52px;
                        }
                    }
                    img {
                        // width: 100%;
                        // width: 100%;
                        // position: absolute;
                        // left: 0;
                        // top: 50%;
                        // -webkit-transform: translateY(-50%);
                        // transform: translateY(-50%);
                        height: 135px;
                        width: 135px;
                        object-fit: contain;
                    }
                }
                .addCart {
                    display: inline-block;
                    width: 102px;
                    font-size:14px;
                    color: #666666;
                    margin-bottom: 20px;

                    img {
                        width: 22px;
                        height: 25px;
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                }
                .goodName {
                    font-size:16px;
                    color: #333333;
                    margin-bottom: 10px;

                    &.brandName {
                        font-weight: 600;
                        color: #333;
                    }
                }
                .goodprice {
                    .mobilePrice{
                        display: inline-block;
                    }
                    del {
                        color: #B0B4BF;
                        // margin-right: 20px;
                    }
                    span {
                        color: #FF4650;
                    }
                }
            }
        }

        .redirct {
            font-size:24px;
            line-height:33px;
            margin-top: 54px;
            padding-bottom: 70px;

            .completion {
                background-image: url('../../ico/blueSucccess@2x.png');
                background-position: 0 0;
                background-size: contain;
            }
        }

        .mobile_refine {
            background-color: #ebebeb !important;
            .tab {
                height: 50px !important;
                display: block !important;
                border-bottom: 1px solid transparent !important;
                color: #333 !important;
                font-size: 10px !important;
                line-height: 50px !important;
                overflow: hidden !important;
                padding-left: 15px !important;
                text-transform: none !important;
                background-color: #fff !important;
                border-color: #ebebeb !important;
                font-weight: 500 !important;
            }

        }
        .mobile_tagList {
            height: 370px !important;
            overflow-y: scroll !important;
            margin-bottom: 10px;
            .input {
                height: 35px !important;
                width: 100% !important;
                display: block !important;
                background-color: #f5f5f5 !important;
                border: 1px solid #e1e1e1 !important;
                border-radius: 5px !important;
                line-height: 35px !important;
                text-align: center !important;
                padding: 8px 15px;
                font-size: 13px;
                margin-top: 10px;
            }
            .mobie_tag {
                height: 45px !important;
                width: 100% !important;
                display: block !important;
                position: relative !important;
                border-bottom: 1px solid #f0f0f0 !important;
                color: #666 !important;
                font-size: 14px !important;
                font-weight: 400 !important;
                line-height: 50px !important;
                padding-left: 15px !important;
                padding-right: 15px !important;
                background-color: #fafafa;
                &.checked {
                    background-color: #fff !important;
                }

                img {
                    position: absolute !important;
                    right: 15px !important;
                    top: 50% !important;
                    margin-top: -8px !important;
                    height: 16px;
                    width: 16px;
                }
            }
            // .mobie_tag:hover {
            //     background-color: #333;
            // }
        }
        .sortList {
            height: 50px !important;
            width: 100% !important;
            display: block !important;
            position: relative !important;
            border-bottom: 1px solid #f0f0f0 !important;
            color: #666 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            line-height: 50px !important;
            padding-left: 15px !important;
            padding-right: 15px !important;
            &.selected{
                color: #396bf1 !important
            }
            .sortImg {
                position: absolute !important;
                right: 15px !important;
                top: 50% !important;
                margin-top: -8px !important;
            }
        }
    }
    @media screen and (max-width:1024px){
        .contioner {
            padding: 0 0;
            margin: 80px auto 0;
            .goodsList {
                width: 100%;

                .goodName {
                    font-size: 14px !important;
                }
            }
            .select {
                float: none;
                margin: 0 auto;
                width: 200px;
            }

            .goodprice {
                .mobilePrice {
                    display: block;
                }

            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/pages/goods/GoodsList.vue